import * as R from 'ramda';
import { handleActions } from 'redux-actions';
// feature board
import {
  boardRoutine,
  boardPaginationRoutine,
} from './routines';
//////////////////////////////////////////////////

const initialState = {
  page: 0,
  size: 50,
  total: 0,
  fields: [],
  boardList: [],
  orderFields: [],
  searchCriteria: [],
};

const boardPaginationRoutineTrigger = (state, { payload }) => (
  R.mergeLeft({ size: payload.size, page: payload.page }, state)
);

const boardRoutineSuccess = (state, { payload }) => (
  R.mergeLeft({
    page: payload.page, size: payload.size, total: payload.total, boardList: payload.elements,
  }, state)
);

export default handleActions({
  [boardRoutine.FETCH_SUCCESS]: boardRoutineSuccess,
  [boardPaginationRoutine.SUCCESS]: boardPaginationRoutineTrigger,
}, initialState);
